import { useMutation } from '@tanstack/react-query';

import { MutationError } from '../../shared/ui/mutation-error';
import {
  PeriodPicker,
  flowSourceWords,
  inheritsWords,
  periodLabel,
  setFlowPeriod,
  useRefreshStorage,
  warningText,
  type TFlowLevel,
  type TRetentionPeriod,
} from '../../entities/retention';

export const useFlowPeriod = () => {
  const refresh = useRefreshStorage();
  return useMutation({
    mutationFn: ({ flowId, period }: { flowId: string; period: TRetentionPeriod | null }) =>
      setFlowPeriod(flowId, period),
    onSuccess: refresh,
  });
};

/** A flow's period on a Storage row: follow its folder, or its own exception (board S2). */
export const FlowPeriod = ({ flow }: { flow: TFlowLevel }) => {
  const save = useFlowPeriod();
  return (
    <>
      <PeriodPicker
        aria-label={`How long ${flow.name} keeps things`}
        title={`${flow.name} keeps`}
        value={flow.keeps.period}
        own={flow.ownPeriod}
        source={flowSourceWords(flow)}
        follow={{
          label: `Follow ${inheritsWords(flow.inherits)}`,
          period: flow.inherits.period,
        }}
        holdSeconds={flow.warning?.seconds ?? flow.holdSeconds}
        warning={flow.warning ? warningText(flow.warning, flow.keeps.period) : null}
        caution={flow.warning !== null}
        disabled={save.isPending}
        onChoose={(period) => save.mutate({ flowId: flow.flowId, period })}
      />
      <MutationError error={save.error} />
    </>
  );
};

export const followWords = (flow: TFlowLevel): string =>
  `${inheritsWords(flow.inherits) === 'the default' ? 'Default' : inheritsWords(flow.inherits)} · ${periodLabel(flow.inherits.period)}`;
